import { authtoken } from './../app/services/business-group-management.service';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { active_session_details } from './../app/services/users.service';
import { CookieService } from 'ngx-cookie-service';
let user_cms_token = localStorage.getItem('user_cms_token');
export const environment = {
  production: false,
  //apiURL : 'https://instaottapi.ratri.app/',
  apiURL : 'https://preprodapi.ratri.app/',
  authtoken: 'DxfshCiK7iWqezcDUMvy',
  cmsauthtoken: 'aQYvGrc25BbFjyz9nkZF',
  drmUrl:'http://101.53.134.118:9200/'
  
};

if(user_cms_token === 'undefined'){
  environment.authtoken ='DxfshCiK7iWqezcDUMvy'
  //environment.authtoken ='wzqrVseYGqVyEqyT8Dpt'
}


// if(user_cms_token === 'undefined'? environment.authtoken:user_cms_token)




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
